import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/Event/KTechPioneers/index.tsx");
